function change_facebook_url(crcode)
{
  switch (crcode) {
    case "AUD":
      fburl = "https://www.facebook.com/TrincaFerroAustralia/";
      $("#footer-facebook").attr("href",fburl);
      break;
    case "EUR":
      fburl = "https://www.facebook.com/TrincaFerroDeutchland/";
      $("#footer-facebook").attr("href",fburl);
      break;
    case "GBP":
      fburl = "https://www.facebook.com/Trinca.Ferro.Boutique";
      $("#footer-facebook").attr("href",fburl);
      break;
    case "USD":
      fburl = "https://www.facebook.com/TrincaFerroUSA/";
      $("#footer-facebook").attr("href",fburl);
      break;
    case "BRL":
      fburl = "https://www.facebook.com/TrincaFerroloja/";
      $("#footer-facebook").attr("href",fburl);
      break;
    case "CAD":
      fburl = "https://www.facebook.com/TrincaFerroUSA/";
      $("#footer-facebook").attr("href",fburl);
      break;
  }
}// function closed

var checkcurrency = function(){
  if($(".currency__current").length){
    
//     $(".currency__switcher").change(function() {
//         var curr_code = $(this).attr("data-code");
//         change_facebook_url(curr_code);
//     });
    
    clearTimeout(interval);
    var currency_code = $(".currency__current").attr("data-code");
    console.log(currency_code);
    change_facebook_url(currency_code);
  }
  else
  {
    checkcurrency();
  }
}// closed
  
// call this function
//var interval = setInterval(checkcurrency,1000);

